import React, { Component } from "react";
import {Button, FormControl, InputGroup, Row, Col, Table, Modal} from 'react-bootstrap'
import _ from 'lodash';
import '../../Resources/css/NewForm.css';
let newObject = [{'label':''},{'label':''},{'label':''},{'label':''},{'label':''},{'label':''},
{'label':''},{'label':''},{'label':''},{'label':''}]
export default class NewForm extends Component {
  constructor(props) {
    super(props);
      this.state= this.getinitialState()
  }
  
  getinitialState() {
    const{form} = this.props
    return {
      objects: form ? form.objects : newObject,
      titleName: form ? form.title : '',
      nameExist: false     
    };
  }
  duplicateItems = () => {
    const{objects} = this.state;
    if(objects.length <= 24){
      objects.push({'label':''})
      this.setState({objects})
    }
  }
  removeItems = (index) =>{
    const{objects} = this.state;
    if( index !== 0){
    _.pullAt(objects, index)
    this.setState({objects})
    }
  }
  handleChange = (e, index) => {
    const{objects} = this.state;
    objects[index].label = e.target.value
    this.setState({objects})
  }
  handleChangeName = (e) => {
    this.setState({titleName:e.target.value})
  }
  handleChangeNameTemplate = (e) => {
    this.setState({newTitle:e.target.value})
  }
 
  saveModal = (close) => {
    let content = (
        <InputGroup><InputGroup.Prepend>
       <InputGroup.Text id="basic-addon1"><i class="fas fa-comment"></i>
       </InputGroup.Text>
       </InputGroup.Prepend><input  className='form-control'
        onChange={(e)=>this.handleChangeNameTemplate(e)} placeholder='Template Name'
        value={this.state.newTitle} type='text'/></InputGroup>   
    )   
    return(<Modal show={true}
    onHide={close}
    dialogClassName="modal-90w shadowClass"
    size='sm'
    aria-labelledby="contained-modal-title-vcenter"
    centered>          
    <Modal.Header closeButton>Save changes</Modal.Header>
    <Modal.Body>
     {content}
     {this.state.nameExist1 ? <p className='RedColoring alignRight'>{'Template Name already Exist'}</p> : null
      }
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={this.finalNewChanges}> OK </Button> &nbsp;
      <Button onClick={this.props.closeModal}> Cancel </Button>
    </Modal.Footer>
    </Modal>)    
  }
  handleSaveAs = () => {
    this.setState({saveNew:true})
  }
  handleHideSave = () => {
    this.setState({saveNew:false})
  }
  finalNewChanges = () => {  
    let cc; 
    if(!_.isEmpty(this.props.webFormNames)){
     cc = this.props.webFormNames.filter(obj => _.includes(obj.name.toLowerCase(), this.state.newTitle.toLowerCase()))  
    }
    if(_.isEmpty(cc)){
      const {objects, newTitle} = this.state; 
      let userName = this.props.loginAction.userName
      _.remove(objects, {'label':''})
      let obj={'title':newTitle, 'objects':objects, userName}       
      this.props.action.TokenValidation()  
      this.props.action.addTemplate(obj)
      this.props.closeModal() 
    } else {
      this.setState({nameExist1:true})
    }     
  }
  handleSave = () => {   
    let userName = this.props.loginAction.userName 
    let object = _.cloneDeep(this.state.objects)
    _.remove(object, {'label':''})    
    if(this.props.edit){
      this.props.closeModal()
      let obj={'title':this.state.titleName, 'objects':object, userName} 
      this.props.action.TokenValidation()        
      this.props.action.editTemplate(obj)
      this.setState(this.getinitialState());
    } else {
      let cc;
      if(!_.isEmpty(this.props.webFormNames)){
       cc = this.props.webFormNames.filter(obj => _.includes(obj.name.toLowerCase(), this.state.titleName.toLowerCase()))
      }
      if(_.isEmpty(cc)){
        let obj={'title':this.state.titleName, 'objects':object, userName} 
        this.props.action.TokenValidation()          
        this.props.action.addTemplate(obj)
        this.setState(this.getinitialState());
        this.props.closeModal()
      } else {
        this.setState({nameExist:true})     
      }  
    }    
  }
  render(){
    const {objects, titleName} = this.state;
    const{edit} = this.props;    
    let UI= _.map(objects, (val, index) =>{
       return( <tr >         
       <td md={1}>{index+1}</td>
       <td>
        <FormControl
        aria-label="Search"
        placeholder='Web Form Field Name'
        aria-describedby="basic-addon1"
        onChange={(e) => this.handleChange(e, index)}
        value={val.label}
        /></td>
        <td md={1}><i class='fas fa-plus-circle accord plusicon' onClick={this.duplicateItems}/>
        <i class="fas fa-times-circle accord plusicon" onClick={()=>this.removeItems(index)} />
        </td>
       </tr> )      
    })
    let n = UI.length
    let firstObj = UI
    let secondObj =[]
    if(n>=10){
    firstObj = _.slice(UI, 0, n/2+1)
    secondObj = _.slice(UI, n/2+1, n) }
    return(
      <div>
        <span className="RedColoring alignRightIcon"><i class="fas fa-times" onClick={this.props.closeModal}></i></span><br/>
        <Row className='clearBoth'>        
        <Col>       
        <Table responsive>
            <thead><th></th><th>WEB FORM FIELD NAME</th><th>ADD</th></thead>
            <tbody>
              {firstObj}
            </tbody>
          </Table>  
          </Col><Col>
         { (n>=10) ?
          <Table responsive>
            <thead><th></th><th>WEB FORM FIELD NAME</th><th>ADD</th></thead>
            <tbody>
              {secondObj}
            </tbody>
          </Table>      : null}</Col></Row>
          {/* <Col>{firstObj}</Col>
          <Col>{secondObj}</Col>
        </Row>        */}
        <div className={'SaveAbsolute'}>
        {this.state.nameExist ? <span className='RedColoring'>{'Template Name already Exist'}</span> : null}<br/>		
          <p>	
         	<FormControl
						placeholder="Web Form Name"
						aria-label="Web Form Name"
						aria-describedby="basic-addon1"
					  onChange={(e) => this.handleChangeName(e)}
            value={titleName}
            disabled={edit ? edit :false}
						/>
			  &nbsp;<Button className='buttonwidth' size='md' onClick={this.handleSave}>SAVE</Button> &nbsp;
        {edit ? <Button  className='buttonwidth' size='md' onClick={this.handleSaveAs}>SAVE AS</Button> : null }</p>          
          {this.state.saveNew ? this.saveModal(this.handleHideSave) : null }
        
        </div>
      </div>

    )
  }
}